import React, { createContext, useState, ReactNode } from 'react';
import { Device, Page, Group } from '../model/types';

// Cihaz verilerini sağlayacak context
interface DeviceContextType {
  tesisName: string[];
  setTesisName: React.Dispatch<React.SetStateAction<string[]>>;
  devices: Device[];
  setDevices: React.Dispatch<React.SetStateAction<Device[]>>;

  pages: Page[];
  setPages: React.Dispatch<React.SetStateAction<Page[]>>;


  // expandedPages: { [key: string]: boolean }; // string key'lerle boolean değerler tutan obje
  // setExpandedPages: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;

  groups: Group[];
  setGroups: React.Dispatch<React.SetStateAction<Group[]>>;

  expandedGroups: { [key: string]: boolean }; // string key'lerle boolean değerler tutan obje
  setExpandedGroups: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;

  activePage: string;
  setActivePage: React.Dispatch<React.SetStateAction<string>>;

}

// DeviceContext oluşturuluyor, başlangıçta boş.
export const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

interface DeviceProviderProps {
  children: ReactNode;
}

// DeviceProvider bileşeni, alt bileşenlerin device listesini kullanabilmesi için cihaz bilgilerini sağlar.
export const DeviceProvider: React.FC<DeviceProviderProps> = ({ children }) => {
  const [tesisName, setTesisName] = useState<string[]>([]);
  const [devices, setDevices] = useState<Device[]>([]);
  const [pages, setPages] = useState<Page[]>([]);
  const [groups, setGroups] = useState<Group[]>([]);
  //const [expandedPages, setExpandedPages] = useState<{ [key: string]: boolean }>({});

  // const [expandedPages, setExpandedPages] = useState<{ [key: string]: boolean }>(
  //   Object.fromEntries(pages.map((page) => [page.pageId, true])) // Başlangıçta tüm sayfalar açık
  // );
  const [expandedGroups, setExpandedGroups] = useState<{ [key: string]: boolean }>(
    Object.fromEntries(groups.map((group) => [group.groupId, true])) // Başlangıçta tüm sayfalar açık
  );

  const [activePage, setActivePage] = useState<string>("");
  // const [activePage, setActivePage] = useState<string>(pages.length > 0 ? pages[0].pageId : "xxx");

  return (
    <DeviceContext.Provider value={{ tesisName, setTesisName, devices, setDevices, pages, setPages, groups, setGroups, expandedGroups, setExpandedGroups, activePage, setActivePage }}>
      {children}
    </DeviceContext.Provider>
  );
};
